module.exports = __webpack_public_path__ + "img/Efficiency Icon - white.274da528.svg";